import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { useReporteAmbiental } from '@/hooks/useReporteAmbiental';
import { ReporteFormatoICA } from '@/components/reportes/ReporteFormatoICA';
import { ExportarReporte } from '@/components/reportes/ExportarReporte';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useState } from 'react';
import logoViable from '@/assets/logo-viabiliza.png';

export default function ReporteAmbientalDetalle() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { datosReporte, loading } = useReporteAmbiental(id);
  const currentYear = new Date().getFullYear();
  const [periodo, setPeriodo] = useState(currentYear.toString());

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!datosReporte) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Card className="max-w-md">
          <CardContent className="py-12">
            <p className="text-center text-muted-foreground">
              No se encontraron datos para esta obligación
            </p>
            <Button 
              className="w-full mt-4" 
              onClick={() => navigate('/reporte-ambiental')}
            >
              Volver a Reportes
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  const years = Array.from({ length: 5 }, (_, i) => currentYear - 2 + i);

  return (
    <div className="min-h-screen bg-muted/30">
      {/* Header */}
      <header className="sticky top-0 bg-card/95 backdrop-blur-sm border-b border-border z-50 shadow-sm">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <img src={logoViable} alt="Viabiliza" className="h-10" />
              <div>
                <h1 className="text-lg font-bold text-foreground">
                  {datosReporte.obligacion.codigo} - {datosReporte.obligacion.nombre_programa}
                </h1>
                <p className="text-xs text-muted-foreground">Reporte de Cumplimiento - Formato ICA-1a</p>
              </div>
            </div>
            <Button variant="outline" onClick={() => navigate('/reporte-ambiental')}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              Volver
            </Button>
          </div>
        </div>
      </header>

      {/* Controles */}
      <div className="container mx-auto px-4 py-6">
        <Card>
          <CardContent className="py-4">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="flex items-center gap-4">
                <label className="text-sm font-medium">Período:</label>
                <Select value={periodo} onValueChange={setPeriodo}>
                  <SelectTrigger className="w-32">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {years.map((year) => (
                      <SelectItem key={year} value={year.toString()}>
                        {year}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <ExportarReporte datos={datosReporte} periodo={periodo} />
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Reporte */}
      <div className="container mx-auto px-4 pb-12">
        <Card className="overflow-hidden">
          <ReporteFormatoICA datos={datosReporte} periodo={periodo} />
        </Card>
      </div>
    </div>
  );
}
